export class GcpSourceAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
